import { GetterTree } from "vuex";
import { ISectorState } from "@/core/interfaces/sectorState.interface";
import { ISector } from "@/core/interfaces/sector.interface";
import {
  ISectorProductivity,
  ISectorStatistics,
} from "@/core/interfaces/sectorProductivity.interface";
import { StoreState } from "@/store/type";

const getters: GetterTree<ISectorState, StoreState> = {
  sectors: (state): Array<ISector> => state.sectors,
  isFetchingSectors: (state): boolean => state.isFetchingSectors,
  isSectorStatsLoading: (state): boolean => state.isSectorStatsLoading,
  isSectorProductivityLoading: (state): boolean =>
    state.isSectorProductivityLoading,
  sectorStats: (state): ISectorStatistics | null => state.sectorStats,
  sectorProductivity: (state): ISectorProductivity | null =>
    state.sectorProductivity,
};

export default getters;
